import React, { useState, useRef, useEffect } from 'react';

export const MessageInput = ({ onSendMessage, disabled, isProcessing = false }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    // Auto-resize textarea
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('=== FORM SUBMIT ===');
    console.log('message:', message);
    console.log('disabled:', disabled);
    console.log('isProcessing:', isProcessing);
    console.log('message.trim():', message.trim());
    console.log('conditions met:', message.trim() && !disabled && !isProcessing);
    
    if (message.trim() && !disabled && !isProcessing) {
      console.log('Calling onSendMessage with:', message.trim());
      onSendMessage(message.trim());
      setMessage('');
      console.log('Message cleared, form submitted');
    } else {
      console.log('Form submission blocked');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="bg-white border-t border-gray-200 p-4">
      <form onSubmit={handleSubmit} className="flex items-center space-x-3">
        <div className="flex-1">
          <textarea
            ref={textareaRef}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={disabled ? "Conectando..." : isProcessing ? "Procesando..." : "Pregúntame sobre Facturas simples..."}
            disabled={disabled || isProcessing}
            className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
            rows={1}
            maxLength={2000}
          />
        </div>
        
        <button
          type="submit"
          disabled={!message.trim() || disabled || isProcessing}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 min-w-[100px] h-12"
        >
          {isProcessing ? (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <>
              <span>Enviar</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
            </>
          )}
        </button>
      </form>
    </div>
  );
};
